import { RouteRecordRaw } from 'vue-router';

export const WorkspaceRoutes = [
  {
    path: 'domains/:domainId/validate',
    name: 'domain-validation',
    component: () =>
      import('@/views/WorkspaceSetup/WorkspaceDomainValidation.vue'),
    meta: {
      authorize: false,
    },
    props: true,
  },
  {
    path: '',
    component: () => import('@/views/Workspaces/WorkspaceRedirect.vue'),
    props: true,
  },
] as const satisfies RouteRecordRaw[];
